import { shortFormatCurrency } from 'lib/utils/currency';
import { isMobile } from 'lib/utils/UiUtils';

export const afterScaleFit = scale => {
    let tl = shortFormatCurrency(scale.max).length;
    scale.width = tl <= 3 ?
        (isMobile() ? 40 : 100) :
        (isMobile() ? 50 : 100);
    // scale.max < 100000 ?
    //     (isMobile() ? 40 : 90) :
    //     (isMobile() ? 50 : 110);
}

export const scaleFormatCurrency = value => {
    return shortFormatCurrency(parseFloat(value));
    // return isMobile() ? shortFormatCurrency(parseFloat(value)) :
    // `$${parseFloat(value).toLocaleString(
    //     undefined,
    //     { minimumFractionDigits: 0, maximumFractionDigits: 0 }
    // )}`;
}

// TypeScript would really help with these 2 functions
// takes the max and finds closest number that is evenly divisible by 3.
// why 3? Also, why not Math.round(x /3)?
export const scaleMax = (sMax, resolution) => {
    // @NOTE: sMax is always a number, why not parseInt. Or is it sometimes an array of numbers with a period thrown in? Also wouldn't add the "s", implies a string and it generally isn't done.
    // @NOTE: Not sure what s, l, d and r stand for
    // @NOTE: Why not floor.ceil, no string conversion neded. Always a number.
    let s = sMax.toString().split('.')[0];
    let l = s.length; // == 1 ? 2 : s.length;
    let d = Math.pow(10, l); // get divisor to decimal
    let r = sMax / d; // get the size between 0 and 1;

    // find a suggested maximum
    //@ NOTE: Would just raname to suggestedMaximum
    let sm = r;
    //@ NOTE: Can this be killed, not used as it is passed in?
    //let resolution = .2;
    // @NOTE: Wouldn't use _ for constiency, standardd
    let _c = 0;
    while (_c <= 1) {
        _c += resolution;
        if (r < _c) {
            sm = _c;
            break;
        }
    }

    return sm * d; // put range back to previous
    // console.log('...', l, d, r, '=', c)
}

// returns a maximum "slightly ahead" of the passed in values
// avg is always a number, and can’t be greater than the max by definition, so why pass in? (See first two lines)
export const findSuggestedMax = (avg, maxVal, dailyGoal, resolution = .1) => {
    let max = Math.max(avg, maxVal, dailyGoal);

    // @NOTE: This no longer appears used, factor doesn't do anything
    let factor = 1;
    // if daily goal is above averages, raise graph a bit.
    if (avg < dailyGoal && dailyGoal < (avg*1.35)) {
        // @NOTE: Would centralize this magic 1.35 number to a const somewhere
        factor = 1.35;
    }

    // @NOTE: Remove dead code, use const for suggestedMax
    let suggestedMax = scaleMax(max, resolution);// * factor);// * 1.5;
    return suggestedMax;
}

export const layoutLeftPadding = () => isMobile() ? 0 : 0;
export const barThickness = () => isMobile() ? 3 : 10;
export const tickPadding = () => isMobile() ? 5 : 15;
export const doughnutThickness = (isBottom) => (isBottom ? 4 : 8);
export const tickColor = '#8c93a0';
export const tooltipPadding = 7;

// 128751
// / 10000

// 125
// 100  / 3